import { NamespaceConsumer, withNamespace, NamespaceShape } from '@ux/namespace-component';
import React from 'react';

/**
 * Create divider which visually seperates DropdownItems.
 *
 * @class DropdownDivider
 * @displayName DropdownDivider (Web)
 * @public
 */
class DropdownDivider extends NamespaceConsumer {
  render() {
    return (
      <div role='presentation' className={ this.namespace('dropdown-divider') } />
    );
  }
}

DropdownDivider.propTypes = {
  /** Namespace Consumer props */
  ...NamespaceShape
};

export default withNamespace(DropdownDivider);
